"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTANTS = void 0;
const CONSTANTS = exports.CONSTANTS = {
  "toApproveRequestTitle": "To approve a request:",
  "toApproveRequestTitleDes": "Please select Role and <MineSiteLabel> for each user you want to approve. Then select 'Approve'.",
  "toRejectRequestTitle": "To reject a request:",
  "toRejectRequestTitleDes": "For each user you want to reject, just select 'Reject'. You don't have to select a Role and <MineSiteLabel>.",
  "youCanApproveOrRejectTitle": "You can approve and/or reject multiple users at the same time. Any users you are not ready to approve/reject will remain as pending and can be reviewed later.",
  "onceYouSelectedTitle": "Once you have selected the corresponding fields for each request you want to approve/reject, click Submit.",
  "completedRequestsHeaderText": "The table below contains all the access requests that have been Approved or Rejected.",
  DATE_TIME: 'Date & Time',
  USER: 'User',
  COMPANY: 'Company',
  COUNTRY: 'Country',
  APPLICATION: 'Application',
  ROLE: 'Role',
  APPROVE: 'Approve',
  REJECT: 'Reject',
  SUBMIT: 'Submit',
  REJECTED: 'Rejected',
  ACCEPTED: 'Approved',
  ACCESS_REQUESTS_TABLE_HEADER: 'Access Requests by Application',
  NO_RESULTS_TEXT: 'There are no access requests pending for review',
  PENDING_REQUESTS: 'Pending Requests',
  COMPLETED_REQUESTS: 'Completed Requests',
  ROLES: {
    APP_MANAGER: 'App Manager',
    GLOBAL_APP_MANAGER: 'Global App Manager'
  },
  STATUS: 'Status',
  REVIEWED_BY: 'Reviewed by',
  COMPLETED_REQUESTS_TABLE_TITLE: 'Completed Requests',
  SAVE_PENDING_ACCESS_REQUESTS: 'SAVE_PENDING_ACCESS_REQUESTS',
  SAVE_ACCESS_REQUEST_ROLES: 'SAVE_ACCESS_REQUEST_ROLES',
  SAVE_APPLICATION_BUSINESS_ENTITIES: 'SAVE_APPLICATION_BUSINESS_ENTITIES',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  APPLICATION_MANAGER: 'ApplicationManager',
  SELECT_ATLEAST_ONE_ERROR: 'You have to approve or Reject a request before clicking the Submit.',
  APPROVED_SUCCESS_MESSAGE: 'You approved {approvedCount} access requests. Users will be notified automatically.',
  REJECTED_SUCCESS_MESSAGE: 'You rejected {rejectedCount} access requests. Users will be notified automatically.',
  APPROVED_REJECTED_SUCCESS_MESSAGE: 'You approved {approvedCount} access requests. You rejected {rejectedCount} access requests. Users will be notified automatically.',
  ALERT: 'alert',
  UNABLE_SUBMIT: 'Unable to Submit',
  SUBMIT_REQUESTS_ERROR: 'You have to Approve or Reject a request before clicking Submit.',
  MESSAGE: 'message',
  SUBMIT_SUCCESS: 'Successfully submitted',
  SELECT_ROLE: 'Select role',
  SELECT_MINE_SITE: 'Select <MineSiteLabel>'
};